import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/actions/auth.action';

export default function SearchProduct({ updateProduct=null, item=null, defaultValue=null, required=false, reset=false, id="product_id" }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [q, setQ] = useState("");
    const [product, setProduct] = useState(defaultValue);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        if(reset){
            setIsTouched(false);
        }
    }, [reset]);

    const searchProducts = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }products/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setProducts(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchProducts();
    }, [searchProducts, location]);

    useEffect(() => {
        if(q.length >= 2){
            searchProducts(q);
        }
    }, [searchProducts, q]);
    
    useEffect(() => {
        setQ("");
        if(updateProduct && product){
            updateProduct(product);
        }
    }, [updateProduct, product]);

    useEffect(() => {
        setProduct(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ `${ id }${ item !== null ? '_' + item : '' }` } className='form-control'>{ product ? product.code + " - " + product.name : 'Rechercher un produit' }</label>
                <input type='text' ref={ autocompleteInputRef } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} id={ `${ id }${ item !== null ? '_' + item : '' }` } placeholder={ product ? product.code + " - " + product.name : 'Rechercher un produit' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { products.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setProduct(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> { item.code + " - " + item.name }</li>
                        )
                    }) }
                    { products.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { required && isTouched && product === null && <div className='form-error'>Veuillez sélectionner le produit.</div> }
        </>
    )
}
